import { Component, OnInit } from '@angular/core';
import { RoomViewService } from 'src/app/modules/rooms/services/room-view.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(private roomViewService: RoomViewService) {}

  ngOnInit() {}

  onRouteToRooms() {
    this.roomViewService.setSelectedFloor(null);
  }

}
